








































import { Vue, Component, Prop } from "vue-property-decorator";
import * as data from "../../_store/data.module";
import DocReviewDialog from "../Dialogs/DocReviewDialog.vue";
import DocSignDialog from "../Dialogs/DocSignDialog.vue";
import { bus } from "../../main";

@Component({
    components: {
        DocReviewDialog,
        DocSignDialog
    }
})
export default class IspezioneDoc extends Vue {
    @Prop() idDoc!:number;
    @Prop() dataDoc!:string;
    @Prop() tipoDoc!:string;
    @Prop() soggetto!: string;

    private show: boolean;
    private docType: string;
    private ispezione: any

    constructor() {
        super()
        this.show = true
        this.docType = "";
        this.ispezione = {}
    }

    loadIspezione(){
        var payload = {
            idIspezione: this.idDoc
        }
        data.dispatchIspezione(this["$store"], payload)
        .then(response => {
            this.ispezione = response
        })
        .catch(error => {
            if (error.response.status === 401) {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                this["$router"].push("/login");
            } else {
                bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            }
        });
        
    }

    openIspezione() {
        this.docType = "ispezione";
        bus.$emit("openDocIspezioneReview", this.ispezione);
    }

    created(){
        this.loadIspezione()

        bus.$on("closeDocReview", async () => {
            this.show = false;
            await this.$nextTick();
            this.show = true;
        });
    }
}
